<div *ngIf="isBusy === false" class="col-xl-12 draggable">
    <div class="card shadow-none bg-transparent" [ngClass]="{
        'border-danger' : (ticketTaskResult.priority === priority.VeryHigh),
        'border-warning' : (ticketTaskResult.priority === priority.High),
        'border-primary' : (ticketTaskResult.priority === priority.Medium),
        'border-info' : (ticketTaskResult.priority === priority.Low),
        'border-secondary' : (ticketTaskResult.priority === priority.VeryLow)}">
        <div class="card-body">
            <p style="word-break: break-word; margin-right: 50px;"><strong>#{{ticketTaskResult.id}} </strong>- {{ticketTaskResult.title}}</p>
            <div ngbDropdown>
                <button rippleEffect class="btn btn-sm border-0 p-0 hide-arrow" ngbDropdownToggle type="button"
                    id="dropdownItem4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i data-feather="more-vertical" class="font-medium-3 cursor-pointer"></i>
                </button>
                <button type="button" class="btn btn-sm border-0 p-0 hide-arrow" tooltipClass="fadeInAnimation" placement="top"
                    ngbTooltip="{{'TicketDetail' | translate}}" (click)="demonstrateTicket(ticketModal)">
                    <i class="fa fa-eye"></i>
                </button>
                <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownItem4">
                    <a ngbDropdownItem (click)="createSubTask()">{{'AddSubTask' | translate}}</a>
                    <a ngbDropdownItem (click)="showSubTasks()">{{'ShowSubTasks' | translate}}</a>
                    <a ngbDropdownItem (click)="hideSubTasks()">{{'HideSubTasks' | translate}}</a>
                    <a ngbDropdownItem (click)="showSubtaskDetail(subtaskDetailModal)">{{'SubTaskDetail' |
                        translate}}</a>
                    <a ngbDropdownItem (click)="openAddOreditTagsModal(addOrEditTagsModal)">{{'Tag' | translate}}</a>
                    <a ngbDropdownItem (click)="demonstrateTicket(ticketModal)">{{'Ticket' | translate}}</a>
                    <a ngbDropdownItem (click)="demonstrateTicketHistory(ticketHistoryModal)">{{'TicketHistory' |
                        translate}}</a>
                    <a ngbDropdownItem *ngIf="ticketTaskResult.ticketStatus === ticketStatus.Done"
                        (click)="closeTicket()">{{'CloseTicket' | translate}}</a>
                </div>
            </div>
            <p><strong>{{"Project" | translate}}</strong> {{ticketTaskResult.projectName}}</p>


            <p><strong>{{"Customer" | translate}}</strong> {{ticketTaskResult.customerName}}</p>
            <app-assign [assignedEmployeeId]="ticketTaskResult.assignedEmployeeId" [token]="token"
                [assignedEmployeeFullName]="ticketTaskResult.assignedEmployeeFullName"
                [assignedEmployeePersonalPictureFileName]="ticketTaskResult.assignedEmployeePersonalPictureFileName"
                [employeeDropdown]="employeeDropdown" (employeeAssigned)="assigned($event)"></app-assign>
            <section id="subTaskSection" *ngIf="subTasks.length > 0">
                <div class="divider">
                    <div class="divider-text">{{'SubTasks' | translate}}
                        ({{getSubtaskCount()}}/{{subTasks.length}})</div>
                </div>
                <label>{{'Assignee' | translate}}: {{getSubtaskAssigneeCount()}}/{{subTasks.length}}</label>
                <button type="button" class="btn btn-sm btn-flat-success" rippleEffect (click)="createSubTask()">
                    <span data-feather="plus" [class]="'mr-25'"></span>{{'AddSubTask' | translate}}</button>
                <ng-container *ngFor="let item of subTasks">
                    <div *ngIf="item.id === 0" class="input-group input-group-merge">
                        <input type="text" class="form-control form-control-sm" placeholder="{{item.title | translate}}"
                            [(ngModel)]="item.title" />
                        <div class="input-group-append" (click)="addSubTask(item)">
                            <span class="input-group-text cursor-pointer"><i data-feather="check"></i></span>
                        </div>
                        <div class="input-group-append" (click)="cancelSubTask(item)">
                            <span class="input-group-text cursor-pointer"><i data-feather="x"></i></span>
                        </div>
                    </div>
                    <div class="titleDiv" *ngIf="item.id !== 0">
                        <div *ngIf="item.isEditMode === true" class="input-group input-group-merge">
                            <input type="text" class="form-control form-control-sm"
                                placeholder="{{item.title | translate}}" [(ngModel)]="item.title" />
                            <div class="input-group-append" (click)="editSubTask(item)">
                                <span class="input-group-text cursor-pointer"><i data-feather="check"></i></span>
                            </div>
                            <div class="input-group-append" (click)="cancelSubTask(item)">
                                <span class="input-group-text cursor-pointer"><i data-feather="x"></i></span>
                            </div>
                        </div>
                        <div *ngIf="item.isEditMode === false" class="custom-control custom-checkbox" [ngClass]="{
                                'custom-control-danger' : (ticketTaskResult.priority === priority.VeryHigh),
                                'custom-control-warning' : (ticketTaskResult.priority === priority.High),
                                'custom-control-primary' : (ticketTaskResult.priority === priority.Medium),
                                'custom-control-info' : (ticketTaskResult.priority === priority.Low),
                                'custom-control-secondary' : (ticketTaskResult.priority === priority.VeryLow)}">
                            <input type="checkbox" class="custom-control-input" id="checkbox{{item.id}}"
                                name="checkbox{{item.id}}" [(ngModel)]="item.isDone"
                                (ngModelChange)="changeIsDone(item)" />
                            <label class="custom-control-label" for="checkbox{{item.id}}" *ngIf="item.isDone === false"
                                [ngClass]="{
                                    'text-danger' : (ticketTaskResult.priority === priority.VeryHigh && item.assignedEmployeeId !== null),
                                    'text-warning' : (ticketTaskResult.priority === priority.High && item.assignedEmployeeId !== null),
                                    'text-primary' : (ticketTaskResult.priority === priority.Medium && item.assignedEmployeeId !== null),
                                    'text-info' : (ticketTaskResult.priority === priority.Low && item.assignedEmployeeId !== null),
                                    'text-secondary' : (ticketTaskResult.priority === priority.VeryLow && item.assignedEmployeeId !== null)}">{{item.title}}
                            </label>
                            <label class="custom-control-label" for="checkbox{{item.id}}"
                                *ngIf="item.isDone !== false"><del>{{item.title}}</del></label>
                        </div>
                        <div class="buttons" *ngIf="item.isEditMode === false && item.isDone === false">
                            <button type="button" class="btn btn-icon" rippleEffect
                                (click)="openSubtaskAssignModal(subtaskAssignModal, item)">
                                <span data-feather="corner-down-right"></span></button>
                            <button type="button" class="btn btn-icon" rippleEffect (click)="changeToEditMode(item)">
                                <span data-feather="edit-2"></span></button>
                            <button type="button" class="btn btn-icon" rippleEffect
                                (click)="openAlertModal(modalDanger, item.id)">
                                <span data-feather="trash"></span></button>
                        </div>
                    </div>
                </ng-container>
            </section>
            <section id="tagsSection">
                <div *ngFor="let item of ticketTaskResult.tags" class="badge " [ngClass]="{
                    'badge-light-danger' : (ticketTaskResult.priority === priority.VeryHigh),
                    'badge-light-warning' : (ticketTaskResult.priority === priority.High),
                    'badge-light-primary' : (ticketTaskResult.priority === priority.Medium),
                    'badge-light-info' : (ticketTaskResult.priority === priority.Low),
                    'badge-light-secondary' : (ticketTaskResult.priority === priority.VeryLow)}">{{item.name}}
                </div>
            </section>
        </div>
    </div>
</div>
<section *ngIf="isBusy === true">
    <div class="text-center">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</section>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="deleteSubTask()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<ng-template #addOrEditTagsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Tag' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col-md-12">
            <div class="form-group">
                <label class="form-label" for="tagDropdownMulti">{{'Tag' | translate}}</label>
                <ng-select [virtualScroll]="true" id="tagDropdownMulti" name="tagDropdownMulti" [items]="tags"
                    class="ng-select-size-sm" [(ngModel)]="tagIdsForInsert" bindLabel="name" bindValue="id"
                    [multiple]="true" [closeOnSelect]="false" [hideSelected]="true">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
            class="btn btn-success mr-1 waves-effect waves-float waves-light" (click)="addOrEditTags()">{{'Add' |
            translate}}</button>
    </div>
</ng-template>
<ng-template #ticketModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Ticket' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-ticket-comment [ticketInput]="ticket" token="dashboardToken" [employeeDropdown]="employeeDropdown"
            (assignedChanged)="assigned($event)" (ticketHasChanged)="onTicketHasChanged($event)"></app-ticket-comment>
    </div>
</ng-template>
<ng-template #ticketHistoryModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'TicketHistory' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-ticket-history [id]="ticketTaskResult.id" [isBusy]="isBusy"></app-ticket-history>
    </div>
</ng-template>
<ng-template #subtaskDetailModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-sub-task-detail [ticketTaskResult]="ticketTaskResult" [employeeDropdown]="employeeDropdown">
        </app-sub-task-detail>
    </div>
</ng-template>
<ng-template #subtaskAssignModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-assign [assignedEmployeeId]="subtask.assignedEmployeeId" [token]="token"
            [assignedEmployeeFullName]="subtask.assignedEmployeeFullName"
            [assignedEmployeePersonalPictureFileName]="subtask.assignedEmployeePersonalPictureFileName"
            [employeeDropdown]="employeeDropdown" (employeeAssigned)="assignedSubtask(subtask.id, $event)">
        </app-assign>
        <label>{{subtask.title}}</label>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>